module.exports = __webpack_public_path__ + "46df687c282540b5a5c13f002ca928a8.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/twitter-active.png
 ** module id = 1553
 ** module chunks = 0
 **/